import { useEffect, useState } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import { getDepartments, addDepartment } from '../../../api/DepartmentAPI'

interface Department {
  id: string
  code: string
  name: string
  createdAt: string
  // createdBy?: {
  //   employeeCode: string
  // }
  createdBy?: string | { employeeCode: string }
}

export default function DeptMaster() {
  const [departments, setDepartments] = useState<Department[]>([])
  const [show, setShow] = useState(false)
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)

  const loadDepartments = async () => {
    try {
      const res = await getDepartments()
      //const data = res?.data?.data ?? res?.data ?? []
      const data = Array.isArray(res?.data) ? res.data : res?.data?.data ?? []

      setDepartments(data)
    } catch (err) {
      console.error('Load departments failed', err)
      setDepartments([])
    }
  }
//   const loadDepartments = async () => {
//   try {
//     const res = await getDepartments()
//     const data = Array.isArray(res?.data) ? res.data : res?.data?.data ?? []

//     const normalized = data.map((d: Department) => ({
//       ...d,
//       code: d.code?.startsWith('DEPT') ? d.code : 'N/A',
//       createdBy: d.createdBy?.employeeCode
//         ? d.createdBy
//         : { employeeCode: 'N/A' },
//     }))

//     setDepartments(normalized)
//   } catch (err) {
//     console.error('Load departments failed', err)
//     setDepartments([])
//   }
// }


  const handleAdd = async () => {
    if (!name.trim()) return alert('Department name required')

    try {
      setLoading(true)
      await addDepartment({ name })
      setName('')
      setShow(false)
      loadDepartments()
    } catch (err) {
      console.error('Add department failed', err)
      alert('Failed to add department')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadDepartments()
  }, [])

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString('en-GB')

  return (
    <div className="card p-4">
      <div className="d-flex justify-content-between mb-3">
        <h4>Department Master</h4>
        <Button onClick={() => setShow(true)}>+ Add Department</Button>
      </div>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th>Department Code</th>
            <th>Department Name</th>
            <th>Created Date</th>
            <th>Created By</th>
          </tr>
        </thead>
        <tbody>
          {departments.length === 0 && (
            <tr>
              <td colSpan={5} className="text-center">
                No departments found
              </td>
            </tr>
          )}

          {departments.map((d, i) => (
            <tr key={d.id}>
              <td>{i + 1}</td>
              <td>{d.code?.startsWith('DEPT') ? d.code : 'N/A'}</td>
              <td>{d.name}</td>
              <td>{formatDate(d.createdAt)}</td>
              {/* <td>{d.createdBy?.employeeCode ?? 'N/A'}</td> */}
              <td>
  {typeof d.createdBy === 'string'
    ? d.createdBy
    : d.createdBy?.employeeCode ?? 'N/A'}
</td>


            </tr>
          ))}
        </tbody>
      </table>

      {/* Add Modal */}
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Department</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            placeholder="Department Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button onClick={handleAdd} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
